import { render, staticRenderFns } from "./CartPromoCodeForm.vue?vue&type=template&id=642fc1d4&scoped=true"
import script from "./CartPromoCodeForm.vue?vue&type=script&lang=js"
export * from "./CartPromoCodeForm.vue?vue&type=script&lang=js"
import style0 from "./CartPromoCodeForm.vue?vue&type=style&index=0&id=642fc1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642fc1d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PromoCodeConditionsModal: require('/app/components/PromoCodeConditionsModal.vue').default,CartPanel: require('/app/components/CartPanel.vue').default})
